<template>
  <section class="resume-section" id="experience">
    <div class="resume-section-content">
      <h2 class="mb-5">Experience</h2>
      <div class="d-flex flex-column flex-md-row justify-content-between mb-5">
        <div class="flex-grow-1">
          <h3 class="mb-0">Boston Web Capability Lead</h3>
          <div class="subheading mb-3">Accenture Digital Products</div>
          <p>I took over the role of Web Director just as our office shut down due to COVID. I have been learning how to lead a remote team while continuing to foster community and individual growth. I work with our sales team to solution deals and staff our engineers. I continue to be a technical lead on projects and support internal research and training efforts. </p>
        </div>
        <div class="flex-shrink-0"><span class="text-primary">March 2020 - Present</span></div>
      </div>
      <div class="d-flex flex-column flex-md-row justify-content-between mb-5">
        <div class="flex-grow-1">
          <h3 class="mb-0">Software Engineer</h3>
          <div class="subheading mb-3">Accenture Digital Products</div>
          <p>I work as a contract engineer to develop innovative apps for clients spanning android, full stack web, and Unity3D. I have been a Lead Developer, Technical Architect, and Project Manager. I helped overhaul our apprentice program to more effectively teach our junior engineers about MVVM and Clean Architecture. I was a founding member of our Houston office helping grow the team from 6 to over 30 people.</p>
        </div>
        <div class="flex-shrink-0"><span class="text-primary">May 2016 - Present</span></div>
      </div>
      <div class="d-flex flex-column flex-md-row justify-content-between mb-5">
        <div class="flex-grow-1">
          <h3 class="mb-0">Research Assistant</h3>
          <div class="subheading mb-3">Florida Polytechnic</div>
          <p>My research focused around the creation of a software defined radio based mesh network testbed called ARCAM-Net. I worked with Python on linux based systems. </p>
        </div>
        <div class="flex-shrink-0"><span class="text-primary">August 2014 - May 2016</span></div>
      </div>
      <div class="d-flex flex-column flex-md-row justify-content-between">
        <div class="flex-grow-1">
          <h3 class="mb-0">Audio Engineer</h3>
          <div class="subheading mb-3">Tivoli Audio</div>
          <p>I generated both analog and digital designs. I was responsible for prototyping many new products. I spent 15% of my time in China addressing concerns with contract manufacturers. </p>
        </div>
        <div class="flex-shrink-0"><span class="text-primary">May 2012 - August 2014</span></div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
name: "Experience"
}
</script>

<style scoped>
h2 {
  text-transform: uppercase;
}

h3 {
  font-weight: 600;
  text-transform: uppercase;
}

.subheading {
  text-transform: uppercase;
}
</style>